import { render, staticRenderFns } from "./RiskSection.vue?vue&type=template&id=8ba04f0e&scoped=true"
import script from "./RiskSection.vue?vue&type=script&lang=js"
export * from "./RiskSection.vue?vue&type=script&lang=js"
import style0 from "./RiskSection.vue?vue&type=style&index=0&id=8ba04f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba04f0e",
  null
  
)

export default component.exports